import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, Eye } from 'lucide-react';
const notifications = [{
  name: 'Martín G.',
  city: 'Buenos Aires',
  action: 'compró',
  time: 'hace 2 min'
}, {
  name: 'Luciana R.',
  city: 'Córdoba',
  action: 'está viendo',
  time: 'ahora'
}, {
  name: 'Diego F.',
  city: 'Rosario',
  action: 'compró',
  time: 'hace 5 min'
}, {
  name: 'Camila P.',
  city: 'Mendoza',
  action: 'compró',
  time: 'hace 3 min'
}, {
  name: 'Facundo L.',
  city: 'La Plata',
  action: 'está viendo',
  time: 'ahora'
}, {
  name: 'Valentina S.',
  city: 'Tucumán',
  action: 'compró',
  time: 'hace 8 min'
}, {
  name: 'Nicolás B.',
  city: 'Mar del Plata',
  action: 'compró',
  time: 'hace 1 min'
}, {
  name: 'Florencia D.',
  city: 'Salta',
  action: 'está viendo',
  time: 'ahora'
}, {
  name: 'Gonzalo M.',
  city: 'Santa Fe',
  action: 'compró',
  time: 'hace 4 min'
}, {
  name: 'Agustina V.',
  city: 'Neuquén',
  action: 'compró',
  time: 'hace 6 min'
}, {
  name: 'Tomás H.',
  city: 'Bahía Blanca',
  action: 'está viendo',
  time: 'ahora'
}, {
  name: 'Julieta C.',
  city: 'San Juan',
  action: 'compró',
  time: 'hace 2 min'
}, {
  name: 'Matías A.',
  city: 'Resistencia',
  action: 'compró',
  time: 'hace 7 min'
}, {
  name: 'Sofía K.',
  city: 'Posadas',
  action: 'está viendo',
  time: 'ahora'
}, {
  name: 'Pablo E.',
  city: 'Paraná',
  action: 'compró',
  time: 'hace 3 min'
}, {
  name: 'Carolina T.',
  city: 'San Luis',
  action: 'compró',
  time: 'hace 9 min'
}, {
  name: 'Ramiro J.',
  city: 'Ushuaia',
  action: 'está viendo',
  time: 'ahora'
}, {
  name: 'Milagros N.',
  city: 'Corrientes',
  action: 'compró',
  time: 'hace 5 min'
}];
export function LiveNotification() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    // Show first notification after 5 seconds
    const initialDelay = setTimeout(() => {
      setVisible(true);
    }, 5000);
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % notifications.length);
        setVisible(true);
      }, 800);
    }, 15000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  // Auto-hide after 6 seconds
  useEffect(() => {
    if (visible) {
      const hideTimer = setTimeout(() => setVisible(false), 6000);
      return () => clearTimeout(hideTimer);
    }
  }, [visible, currentIndex]);
  const notification = notifications[currentIndex];
  const isBuying = notification.action === 'compró';
  return <div className="fixed bottom-6 left-6 z-40" data-id="element-101">
      <AnimatePresence data-id="element-102">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 30,
        x: -20
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 20,
        x: -10
      }} transition={{
        type: 'spring',
        damping: 20,
        stiffness: 300
      }} className="bg-[#1a1a1a] border border-white/10 rounded-xl px-5 py-4 shadow-[0_8px_32px_rgba(0,0,0,0.5),0_0_15px_rgba(37,211,102,0.1)] max-w-xs backdrop-blur-sm" data-id="element-103">
            <div className="flex items-center gap-3" data-id="element-104">
              {/* Icon */}
              <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${isBuying ? 'bg-[#25D366]/20 text-[#25D366]' : 'bg-blue-500/20 text-blue-400'}`} data-id="element-105">
                {isBuying ? <ShoppingBag className="w-5 h-5" data-id="element-106" /> : <Eye className="w-5 h-5" data-id="element-107" />}
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-108">
                <p className="text-white text-sm font-semibold leading-tight" data-id="element-109">
                  {notification.name}
                  <span className="text-gray-500 font-normal" data-id="element-110"> de </span>
                  <span className="text-gray-300" data-id="element-111">{notification.city}</span>
                </p>
                <p className="text-xs mt-0.5" data-id="element-112">
                  <span className={isBuying ? 'text-[#25D366]' : 'text-blue-400'} data-id="element-113">
                    {notification.action} Vendedor de Hierro
                  </span>
                  <span className="text-gray-600 ml-2" data-id="element-114">
                    {notification.time}
                  </span>
                </p>
              </div>
            </div>

            {/* Subtle progress bar */}
            <motion.div initial={{
          scaleX: 1
        }} animate={{
          scaleX: 0
        }} transition={{
          duration: 6,
          ease: 'linear'
        }} className={`h-0.5 mt-3 rounded-full origin-left ${isBuying ? 'bg-[#25D366]/40' : 'bg-blue-500/40'}`} data-id="element-115" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}